<template>
  <div
    class="fixed-top notification-panel"
    style="z-index: 2000;"
  >
    <b-alert
      v-for="notification in notifications"
      :key="notification.id"
      :variant="notification.variant"
      :show="(notification.variant === 'success' || notification.variant === 'warning') ? 2.5 : true"
      dismissible
      @dismissed="onAlertDismissed(notification)"
      class="m-0 rounded-0 text-center"
    >
      {{notification.message}}
    </b-alert>
  </div>
</template>

<script>
import notifier from '../notifier';

export default {
  created() {
    notifier.setNotificationPanel(this);
  },

  data() {
    return {
      maxAvailabelNotificationId: 1,
      notifications: [],
    };
  },

  methods: {

    showSuccess(message, options) {
      const notification = this.createNotification(message, options, 'success');
      this.notifications.push(notification);
    },

    showSuccessAfterTransition(message) {
      this.showSuccess(message, {route: 'next'});
    },

    showWarning(message, options) {
      const notification = this.createNotification(message, options, 'warning');
      this.notifications.push(notification);
    },

    showError(message, options) {
      const notification = this.createNotification(message, options, 'danger');
      this.notifications.push(notification);
    },

    deleteSenderNotifications(sender) {
      if(sender === null) {
        return;
      }
      this.notifications = this.notifications.filter(notification => notification.sender !== sender);
    },

    createNotification(message, options, variant) {

      let sender = null;
      if(options !== undefined && 'sender' in options) {
        sender = options.sender;
      }

      let route = 'current'; // Possible values: current, next, any.
      if(options !== undefined && 'route' in options) {
        route = options.route;
      }

      const notification = {
        id: this.maxAvailabelNotificationId,
        message: message,
        sender: sender,
        route: route,
        variant: variant,
      };
      this.maxAvailabelNotificationId++;
      return notification;
    },

    onAlertDismissed(notification) {
      const index = this.notifications.indexOf(notification);
      if(index !== -1) {
        this.notifications.splice(index, 1);
      }
    },
  },

  watch: {
    $route() {
      // Delete notifications from old route (route === 'current').
      this.notifications = this.notifications.filter(notification => notification.route === 'any' || notification.route === 'next');

      for(let notification of this.notifications) {
        if(notification.route === 'next') {
          notification.route = 'current';
        }
      }
    }
  }
}

</script>

<style>
  .notification-panel {
    pointer-events: none;
  }
  .notification-panel .alert-success {
    background-color: rgba(212, 237, 218, 0.8);
    border-color: rgba(195, 230, 203, 0.5);
  }
  .notification-panel .alert-danger {
    background-color: rgba(248, 215, 218, 0.8);
    border-color: rgba(245, 198, 203, 0.5);
  }
  .notification-panel button.close {
    pointer-events: auto;
  }
</style>
